import {GetterTree} from 'vuex'
import {RootState} from '@/store'
import {SearchState} from '@/store/modules/search/index'
import {KeyValuePair} from '@payroll/optimus-common'

export const getters: GetterTree<SearchState, RootState> = {

    portalTypes(state): KeyValuePair[] {
        return state.portalTypes
    },

    userTypes(state): KeyValuePair[] {
        return state.userTypes
    }
}
